// extracted by mini-css-extract-plugin
module.exports = {"container":"Dices_container__3TB8_","dice":"Dices_dice__2AEUS"};